import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class ClientContactApiService {
  url :string = environment.urlV2 + '/b2b-portal/business-accounts';

  constructor(private http :HttpClient) {}

  /**
   * Get primary contacts
   * @param {number} businessAcountId - Business account / client id
   * @param {any} params
   * @return {Observable}
   */
  getPrimaryContacts(businessAcountId :number, params :any) :Observable<any> {
    return this.http.get(`${this.url}/${businessAcountId}/primary-contacts`, {
      params: params,
    });
  }

  /**
   * setUserAsPrimaryContact
   * @param {number} businessAcountId - Business account / client id
   * @param {number} userAccountId - User id to be set as primary contact.
   * @return {Observable}
   */
  setUserAsPrimaryContact(
    businessAcountId :number,
    userAccountId :number,
  ) :Observable<any> {
    return this.http.put(
      `${this.url}/${businessAcountId}/primary-contacts/${userAccountId}`,
      {},
    );
  }

  /**
   * unsetUserAsPrimaryContact
   * @param {number} businessAcountId - Business account / client id
   * @param {number} userAccountId - User id to be unset as primary contact.
   * @return {Observable}
   */
  unsetUserAsPrimaryContact(
    businessAcountId :number,
    userAccountId :number,
  ) :Observable<any> {
    return this.http.delete(
      `${this.url}/${businessAcountId}/primary-contacts/${userAccountId}`,
      {},
    );
  }

  /**
   * Set user/contact meta info
   * @param {number} businessAcountId - Business account / client id
   * @param {number} userAccountId - User id to be set as primary contact.
   * @param {any[]} userMetaInfo
   * @return {Observable}
   */
  setUserMetaInfo(
    businessAcountId :number,
    userAccountId :number,
    userMetaInfo :any[],
  ) :Observable<any> {
    return this.http.post(
      `${this.url}/${businessAcountId}/contacts/${userAccountId}/meta`,
      { user_meta: userMetaInfo },
    );
  }

  /**
   * Delete user/contact meta info
   * @param {number} businessAcountId - Business account / client id
   * @param {number} userAccountId - User id to be set as primary contact.
   * @param {any[]} userMetaInfo
   * @return {Observable}
   */
  deleteUserMetaInfo(
    businessAcountId :number,
    userAccountId :number,
    userMetaInfo :any[],
  ) :Observable<any> {
    return this.http.put(
      `${this.url}/${businessAcountId}/contacts/${userAccountId}/meta`,
      { user_meta: userMetaInfo },
    );
  }
}
